export default __webpack_public_path__ + "static/media/cubehead.b854c8e1.gif";